import React from 'react';
import {
  EntityKindPicker,
  EntityProcessingStatusPicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';
import {
  FacetedEntityLifecyclePicker,
  FacetedEntityNamespacePicker,
  FacetedEntityOwnerPicker,
  FacetedEntityTagPicker,
  FacetedEntityTypePicker,
} from './index';

export const CatalogIndexFilters = () => (
  <>
    <EntityKindPicker initialFilter="component" />
    <FacetedEntityTypePicker />
    <UserListPicker initialFilter="owned" />
    <FacetedEntityOwnerPicker />
    <FacetedEntityLifecyclePicker />
    <FacetedEntityTagPicker />
    <EntityProcessingStatusPicker />
    <FacetedEntityNamespacePicker />
  </>
);
